export const BILLING_PERIODS = [ 'monthly', 'yearly' ] as const;
export type BillingPeriod = typeof BILLING_PERIODS[number];


export interface Plan {
    features: Feature[];
    id: string;
    isEnterprise?: boolean;
    isPopular?: boolean;
    maxChecks: number;
    monthlyPrice: number | null;
    name: string;
    originalYearPrice: number | null;
    yearPrice: number | null;
    yearlyPrice: number | null;
}


export interface Feature {
    id: string;
    description: string;
    isMajor: boolean;
    /** Строка про участников команды. */
    isTeam?: boolean;
}


export const PLANS: Plan[] = [
    {
        id               : 'free',
        name             : 'Free',
        monthlyPrice     : 0,
        yearlyPrice      : 0,
        originalYearPrice: 0,
        yearPrice        : 0,
        maxChecks        : 5,
        features         : [
            {
                id         : 'free1',
                description: '5 free checks/month',
                isMajor    : true,
            },
            {
                id         : 'free3',
                description: 'Incident notifications',
                isMajor    : false,
            },
        ],
    },
    {
        id               : 'starter',
        name             : 'Starter',
        monthlyPrice     : 99,
        yearlyPrice      : 79,
        originalYearPrice: 1188,
        yearPrice        : 950,
        maxChecks        : 30,
        features         : [
            {
                id         : 'starter1',
                description: '30 checks',
                isMajor    : true,
            },
            {
                id         : 'starter2',
                description: '1 team member',
                isMajor    : false,
                isTeam     : true,
            },
            {
                id         : 'starter3',
                description: 'Incident notifications',
                isMajor    : false,
            },
            {
                id         : 'starter4',
                description: 'Customer support',
                isMajor    : false,
            },
        ],
    },
    {
        id               : 'business',
        name             : 'Business',
        monthlyPrice     : 249,
        yearlyPrice      : 199,
        originalYearPrice: 2988,
        yearPrice        : 2390,
        isPopular        : true,
        maxChecks        : 100,
        features         : [

            {
                id         : 'business1',
                description: '100 checks',
                isMajor    : true,
            },
            {
                id         : 'business2',
                description: '5 team members',
                isMajor    : false,
                isTeam     : true,
            },
            {
                id         : 'business3',
                description: 'Incident notifications',
                isMajor    : false,
            },
            {
                id         : 'business4',
                description: 'Customer support',
                isMajor    : false,
            },
            {
                id         : 'business5',
                description: 'Monthly analytics',
                isMajor    : false,
            },
        ],
    },
    {
        id               : 'business-pro',
        name             : 'Business Pro',
        monthlyPrice     : 399,
        yearlyPrice      : 319,
        originalYearPrice: 4788,
        yearPrice        : 3830,
        maxChecks        : 300,
        features         : [
            {
                id         : 'business-pro1',
                description: '300 checks',
                isMajor    : true,
            },
            {
                id         : 'business-pro2',
                description: '10 team members',
                isMajor    : false,
                isTeam     : true,
            },
            {
                id         : 'business-pro3',
                description: 'Incident notifications',
                isMajor    : false,
            },
            {
                id         : 'business-pro4',
                description: 'Customer support',
                isMajor    : false,
            },
            {
                id         : 'business-pro5',
                description: 'Monthly analytics',
                isMajor    : false,
            },
            {
                id         : 'business-pro6',
                description: 'Individual reports',
                isMajor    : false,
            },
            {
                id         : 'business-pro7',
                description: 'API integration',
                isMajor    : false,
            },
        ],
    },
    {
        id               : 'enterprise',
        name             : 'Enterprise',
        monthlyPrice     : null,
        yearlyPrice      : null,
        originalYearPrice: null,
        yearPrice        : null,
        isEnterprise     : true,
        maxChecks        : 500,
        features         : [
            {
                id         : 'enterprise1',
                description: 'From 500+ checks',
                isMajor    : true,
            },
            {
                id         : 'enterprise2',
                description: 'Up to 30 team members',
                isMajor    : false,
                isTeam     : true,
            },
            {
                id         : 'enterprise3',
                description: 'Incident notifications',
                isMajor    : false,
            },
            {
                id         : 'enterprise4',
                description: 'Customer support',
                isMajor    : false,
            },
            {
                id         : 'enterprise5',
                description: 'Monthly analytics',
                isMajor    : false,
            },
            {
                id         : 'enterprise6',
                description: 'Account management',
                isMajor    : false,
            },
            {
                id         : 'enterprise7',
                description: 'Individual reports',
                isMajor    : false,
            },
            {
                id         : 'enterprise8',
                description: 'API integration',
                isMajor    : false,
            },
        ],
    },
];
